export {
  autoRedirectToLogin,
  clearLoginAttempt,
  hasLoginAttempt,
  loginUrl,
  redirectToLogin,
  redirectToLogout,
  sanitizeInternalPath,
} from './auth'
export {
  apiClient,
  lastSessionKind,
  refreshSession,
  rememberSessionKind,
  type SessionKind,
  sessionExpired,
  UNAUTHORIZED_EVENT,
} from './client'
export { apiErrorText, beginOptimistic } from './optimistic'
export {
  ApiError,
  apiDelete,
  apiGet,
  apiPatch,
  apiPost,
  apiPut,
  apiUpload,
  fileUrl,
  unwrap,
} from './request'

// Ленивая обёртка: mock-слой не попадает в prod-бандл (dynamic import),
// а bootstrap ходит через public API сегмента.
export async function startMockWorker(): Promise<void> {
  const mock = await import('./mock')
  await mock.startMockWorker()
}
